exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol li[data-v-abfdadfa]::marker{font-weight:400}li[data-v-abfdadfa]{font-weight:300}.link[data-v-abfdadfa]{color:#00e;text-decoration:underline;font-size:.8em!important}.v-expansion-panel-header[data-v-abfdadfa]{padding:0 0 0 13px!important}", ""]);

// exports
